import assign from "lodash/assign";
import isArray from "lodash/isArray";
import isNaN from "lodash/isNaN";
import isNil from "lodash/isNil";
import isNumber from "lodash/isNumber";
import isPlainObject from "lodash/isPlainObject";

import resource from "general/resource";

let appointmentResource = resource("appointment"),
    appointmentReservationResource = resource("appointment_reservation"),
    bookResource = resource("book"),
    resourceUriPattern = new RegExp('/api/v1/appointment/([^/]+)/'),
    uuid4Pattern = /^[0-9a-f]{12}4[0-9a-f]{3}[89ab][0-9a-f]{15}$/;

export default {
    /**
     *
     * @param {Number|String} appointmentIdOrResourceUri
     * @returns {*}
     */
    extractAppointmentId(appointmentIdOrResourceUri) {
        var appointmentId = appointmentIdOrResourceUri;
        if (!isNumber(appointmentId)) {
            let match = resourceUriPattern.exec(appointmentId);
            if (isArray(match) && match.length == 2) appointmentId = match.pop();
            if (isNaN(appointmentId) && !uuid4Pattern.test(appointmentId))
                throw new Error(appointmentId + " is not a valid PK value");
        }
        return appointmentId;
    },
    /**
     *
     * @param {Number|String} appointmentIdOrResourceUri
     * @param {Object} [headers]
     * @returns {*}
     */
    getAppointment(appointmentIdOrResourceUri) {
        let appointmentId = this.extractAppointmentId(appointmentIdOrResourceUri);
        return appointmentResource.get(appointmentId);
    },
    /**
     *
     * @param {Object} appointmentData
     * @param {Boolean} [anonymous=true]
     */
    saveAppointment(appointmentData, anonymous=true) {
        let isPOST = isNil(appointmentData.resource_uri),
            method = isPOST ? "post" : "patch";
        var resource = anonymous ? bookResource : appointmentResource,
            headers;

        if (isPOST) {
            appointmentData = assign({}, appointmentData, {
                source_instance: $("#page-data").data("instance-name"),
                is_api: false
            });
        } else {
            if (!isNil(appointmentData.patch_reservation_token_chain) && appointmentData.confirmation_state === "reserved") {
                resource = appointmentReservationResource;
                headers = {
                    Authorization: "ApiTokenChain " + appointmentData.patch_reservation_token_chain
                };
            } else if (!isNil(appointmentData.reservation_token_chain)) {
                resource = appointmentReservationResource;
                headers = {
                    Authorization: "ApiTokenChain " + appointmentData.reservation_token_chain
                };
            } else if (!isNil(appointmentData.release_reservation_token_chain)) {
                resource = appointmentReservationResource;
                headers = {
                    Authorization: "ApiTokenChain " + appointmentData.release_reservation_token_chain
                };
            }
            resource = resource(this.extractAppointmentId(appointmentData.resource_uri));
        }

        return resource[method](appointmentData, headers);
    }
}
